export const APP_CODE = {
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  CART_NOT_FOUND: 'CART_NOT_FOUND',
  CART_ALREADY_PAID: 'CART_ALREADY_PAID',
  INVALID_PRODUCT: 'INVALID_PRODUCT',
  PRODUCT_OUT_OF_STOCK: 'PRODUCT_OUT_OF_STOCK',
};
